'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var makeStyles = require('../../../DesignSystem/Styles/makeStyles.js');
var RadioGroup$1 = require('../../../node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  var _theme$palette, _theme$palette$black, _theme$palette2, _theme$palette2$secon, _theme$palette3, _theme$palette3$error;

  return {
    labelStyle: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$black = _theme$palette.black) === null || _theme$palette$black === void 0 ? void 0 : _theme$palette$black.primary
    },
    labelHelper: {
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$secon = _theme$palette2.secondary) === null || _theme$palette2$secon === void 0 ? void 0 : _theme$palette2$secon.main
    },
    labelError: {
      color: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$error = _theme$palette3.error) === null || _theme$palette3$error === void 0 ? void 0 : _theme$palette3$error.main
    }
  };
});

var RadioGroup = function RadioGroup(_ref) {
  var label = _ref.label,
      helperText = _ref.helperText,
      errorMessage = _ref.errorMessage,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["label", "helperText", "errorMessage", "children"]);

  var error = !!errorMessage;

  var _useStyles = useStyles(),
      labelStyle = _useStyles.labelStyle,
      labelHelper = _useStyles.labelHelper,
      labelError = _useStyles.labelError;

  var labelTypography = React__default["default"].createElement(Typography, {
    className: labelStyle,
    variant: "subtitle2"
  }, label);
  var helperTypography = React__default["default"].createElement(Typography, {
    className: labelHelper,
    variant: "body2"
  }, helperText);
  var errorTypography = React__default["default"].createElement(Typography, {
    className: labelError,
    variant: "caption"
  }, errorMessage);
  var radios = React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      error: error
    });
  });
  return React__default["default"].createElement(Grid, {
    container: true,
    direction: 'column'
  }, label && React__default["default"].createElement(Grid, {
    item: true
  }, labelTypography), helperText && React__default["default"].createElement(Grid, {
    item: true
  }, helperTypography), React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(RadioGroup$1, _objectSpread({}, rest), radios)), errorMessage && React__default["default"].createElement(Grid, {
    item: true
  }, errorTypography));
};

module.exports = RadioGroup;
